import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "kl-vat-groups-list",
  templateUrl: "./vat-groups-list.component.html",
  styleUrls: ["./vat-groups-list.component.scss"],
})
export class VatGroupsListComponent implements OnInit {
  @Input() tabId: string;
  @Input() modalId: string;
  constructor() {}

  ngOnInit() {}
}
